import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme';

export const CUSTOM_FORM_CLASS_NAME = 'CustomForm';
export const CUSTOM_FORM_CLASS_SLOTS = ['root'] as const;

export type CustomFormClassSlot = typeof CUSTOM_FORM_CLASS_SLOTS[number];

export interface CustomFormClasses {
	root: string;
}

export type CustomFormClassKey = keyof CustomFormClasses;

export const getCustomFormUtilityClass = (slot: string) =>
	generateUtilityClass(CUSTOM_FORM_CLASS_NAME, slot);

export const customFormClasses: CustomFormClasses = generateUtilityClasses(
	CUSTOM_FORM_CLASS_NAME,
	['root'],
);

export default customFormClasses;
